import React from 'react';
import Navbar from '../components/Navbar';
import Login from '../components/Login';
import Footer from '../components/Footer';


export default function LoginPage() {
  return (
    <>
        <Navbar></Navbar>
        <Login></Login>
        <Footer></Footer>
    </>
  )
}
